// extracted by mini-css-extract-plugin
module.exports = {"partnerMaskWrapper":"C33Ow"};